import * as actions from './trackActions'
import constant from '../../constant/appConst'

const trackInit = {}
export default (state = trackInit, action) => {
	switch (action.type) {
		case actions.GET_TRACK_SUCCESS:
			if (action.track) {
				return {
					id: action.track.id,
					title: action.track.title,
					hires: action.track.hires,
					album: action.track.album ? {
						id: action.track.album.id,
						pochette: action.track.album && action.track.album.image ? action.track.album.image.large : undefined,
						title: action.track.album.title,
					} : undefined,
					duration: action.track.duration,
					artist: action.track.album && action.track.album.artist ? {
						id: action.track.album.artist.id,
						name: action.track.album.artist.name
					} : undefined,
					performer: action.track.performer,
					orderUrl: action.track.articles && action.track.articles.length ? action.track.articles
						.sort((a, b) => (constant.trackQuality[b.type] || 0) - (constant.trackQuality[a.type] || 0))[0].url
						: ''
				}
			}
			return trackInit
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/track/trackReducer.js